module.exports = __webpack_public_path__ + "img/INF-A-3-II.193e4da4.png";